import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import { useCreateFacultyMutation, useUpdateFacultyMutation } from "api/faculty/faculty.mutation";
import { Modal } from "components/Modal";
import SwitchField from "components/SwitchField";
import TextField from "components/TextField";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/faculty/createUpdateFacultyModal";
import classes from "./style.module.scss";

export const CreateUpdateFacultyModal = ({ open, onClose, defaultData }) => {
  const { handleSubmit, reset, setError, control } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    defaultValues: {
      fa_name: "",
      en_name: "",
      ar_name: "",
      is_active: false,
    },
  });

  const createFacultyMutation = useCreateFacultyMutation();
  const updateFacultyMutation = useUpdateFacultyMutation();
  const loading = createFacultyMutation.isPending || updateFacultyMutation.isPending;

  const handleCloseModal = () => {
    reset({
      fa_name: "",
      en_name: "",
      ar_name: "",
      is_active: false,
    });
    onClose();
  };
  const handleSubmitForm = async (data) => {
    try {
      if (defaultData) {
        await updateFacultyMutation.mutateAsync({ pk: defaultData?.id, data });
      } else {
        await createFacultyMutation.mutateAsync(data);
      }
      toast.success("با موفقیت انجام شد");
      handleCloseModal();
    } catch (err) {
      handleError({ err, setError });
    }
  };

  useEffect(() => {
    if (defaultData) {
      reset({
        fa_name: defaultData?.fa_name,
        en_name: defaultData?.en_name,
        ar_name: defaultData?.ar_name,
        is_active: defaultData?.is_active,
      });
    }
  }, [defaultData]);

  return (
    <Modal
      open={open}
      title={defaultData ? "ویرایش دانشکده" : "ایجاد دانشکده"}
      onClose={handleCloseModal}
      maxWidth="xs"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={loading}
            color={defaultData ? "primary" : "success"}
            onClick={handleSubmit(handleSubmitForm)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid
        container
        spacing={3}
        component="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        className={classes.wrapper}
      >
        <Grid item xs={12}>
          <TextField label="فارسی" required control={control} name="fa_name" />
        </Grid>
        <Grid item xs={12}>
          <TextField label="انگلیسی" required control={control} name="en_name" />
        </Grid>
        <Grid item xs={12}>
          <TextField label="عربی" required control={control} name="ar_name" />
        </Grid>
        <Grid item xs={12}>
          <SwitchField name="is_active" control={control} label="فعال باشد؟" required />
        </Grid>
      </Grid>
    </Modal>
  );
};
